import React, { Component } from 'react';
import { showAxiosError,deepCopyObject } from "../../../helper/helper";
import Alert from 'react-s-alert';
import { request } from "../../../helper/APIUtils";
import SweetAlert from 'react-bootstrap-sweetalert';

class ResetPassword extends Component {
    constructor(props) {
        super(props);
        this.state = { alert: null };
        this.handlePasswordChange = this.handlePasswordChange.bind(this);
    }
    componentDidMount() {
        if (this.props.location && this.props.location.state && this.props.location.state.requirePasswordReset) {
            const { message } = this.props.location.state;
            Alert.error(message, {
                position: 'top-right',
                effect: 'stackslide',
                timeout: 5000,
                html: false
            });
        }
        this.props.resetPasswordFields();
    }

    confirmPasswordUpdate = () => {
        let passwordPayload = deepCopyObject(this.props.passwordPayload);
        if (passwordPayload.currentPassword || this.props.impersonate) {
            if (passwordPayload.newPassword && passwordPayload.newPasswordCopy) {
                const validation = this.props.passwordValidation(passwordPayload.newPassword, "both");
                if (validation.error) {
                    Alert.error(validation.errorMessage, {
                        position: 'top-right',
                        effect: 'stackslide',
                        timeout: 5000,
                        html: false
                    });
                    return;
                }
                if (passwordPayload.newPassword === passwordPayload.newPasswordCopy) {
                    this.handlePasswordChange();
                } else {
                    Alert.error('Uyumsuz Şifre', {
                        position: 'top-right',
                        effect: 'stackslide',
                        timeout: 5000,
                        html: false
                    });
                }
            } else {
                Alert.error('Yeni Şifre Giriniz', {
                    position: 'top-right',
                    effect: 'stackslide',
                    timeout: 5000,
                    html: false
                });
            }
        } else {
            Alert.error('Mevcut Şifrenizi Giriniz', {
                position: 'top-right',
                effect: 'stackslide',
                timeout: 5000,
                html: false
            });
        }
    }


    handlePasswordChange() {
        let self = this;
        let data = deepCopyObject(self.props.passwordPayload);
        if (self.props.impersonate) {
            data.impersonate = deepCopyObject(self.props.impersonate);
        }
        let params = {
            url: `/user/updatePassword`,
            data: data,
            method: 'post'
        };
        request(params).then(() => {
            this.setState({
                alert: (
                    <SweetAlert success
                                title="Şifreniz Başarıyla Güncellendi"
                                confirmBtnText="Tamam"
                                confirmBtnBsStyle="success"
                                onConfirm={() => {
                                    this.setState({alert: null}, () => {
                                        this.props.logOut();
                                    });
                                }}>
                    </SweetAlert>
                )
            });
        }).catch(function (error) {
            showAxiosError(error);
        });
    }

    render() {
        const containerStyle = {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh'
        };

        const formStyle = {
            width: '50%',
            textAlign: 'center'
        };

        const inputContainerStyle = {
            marginBottom: '15px',
            textAlign: 'left',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center'
        };

        const inputStyle = {
            width: '50%',
            padding: '10px',
            boxSizing: 'border-box'
        };

        const buttonContainerStyle = {
            display: 'flex',
            justifyContent: 'center'
        };

        const buttonStyle = {
            width: '30%',
            padding: '10px',
            background: 'linear-gradient(rgba(159, 208, 55, 0.6), #9fd037)',
            border: 'none',
            color: 'white',
            fontSize: '16px',
            cursor: 'pointer'
        };

        const buttonHoverStyle = {
            background: 'linear-gradient(rgba(159, 208, 55, 0.8), #9fd037)'
        };

        const labelStyle = {
            display: 'block',
            textAlign: 'left',
            marginBottom: '5px',
            fontWeight: 'bold',
            width: '50%'
        };

        return (
            <div style={containerStyle}>
                {this.state.alert && this.state.alert}

                <div style={formStyle}>
                    {!this.props.impersonate && (
                        <div style={inputContainerStyle}>
                            <label style={labelStyle} htmlFor="currentPassword">Mevcut Şifre</label>
                            <input
                                style={inputStyle}
                                type="password"
                                name="currentPassword"
                                id="currentPassword"
                                value={this.props.passwordPayload.currentPassword || ''}
                                onChange={(e) => this.props.onChangePasswordPayload(e)}
                            />
                        </div>
                    )}

                    <div style={inputContainerStyle}>
                        <label style={labelStyle} htmlFor="newPassword">Yeni Şifre</label>
                        <input
                            style={inputStyle}
                            type="password"
                            name="newPassword"
                            id="newPassword"
                            value={this.props.passwordPayload.newPassword || ''}
                            onBlur={(e) => this.props.onBlurPasswordPayload(e)}
                            onChange={(e) => this.props.onChangePasswordPayload(e)}
                        />
                    </div>

                    <div style={inputContainerStyle}>
                        <label style={labelStyle} htmlFor="newPasswordCopy">Yeni Şifre (Tekrar)</label>
                        <input
                            style={inputStyle}
                            type="password"
                            name="newPasswordCopy"
                            id="newPasswordCopy"
                            value={this.props.passwordPayload.newPasswordCopy || ''}
                            onChange={(e) => this.props.onChangePasswordPayload(e)}
                        />
                    </div>

                    <div style={buttonContainerStyle}>
                        <button
                            type="button"
                            style={buttonStyle}
                            onMouseOver={(e) => (e.target.style.background = buttonHoverStyle.background)}
                            onMouseOut={(e) => (e.target.style.background = buttonStyle.background)}
                            onClick={() => this.confirmPasswordUpdate()}
                        >
                            Onayla
                        </button>
                    </div>
                </div>
            </div>
        );
    }



}

export default ResetPassword;